import React from 'react';
import './Modal.css';
import plannerIcon from "../../assets/images/Icon=planner.svg";
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';

const SubmitPlanModal = ({ isVisible, onClose, onSubmitClick, isLoading }) => {

    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <div className='content-container'>
                        <div className='icon-container'>
                            <img src={plannerIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Submit Plan' />
                            <BodyMediumRegular
                                color='#384153'
                                text='You will not be to able make changes after submission, are you sure you want to continue?'
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <BodyExtraSmallMedium color='#1E293B' text='Cancel' />
                        </button>
                        <button className='primary-button' onClick={onSubmitClick} disabled={isLoading}>
                            <BodyExtraSmallMedium color='#FFFFFF' text='Submit' />
                        </button>

                    </div>
                </div>
            </div>
        )
    );
};

export default SubmitPlanModal;
